import { render, staticRenderFns } from "./OIDCLogoutPage.vue?vue&type=template&id=57840542"
import script from "./OIDCLogoutPage.vue?vue&type=script&lang=js"
export * from "./OIDCLogoutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports